import * as React from 'react';
import { throttle } from 'throttle-debounce';
import { withSiteData } from 'react-static';
import { connect } from 'react-redux';

import NotFoundComponent from '../../components/NotFoundPage/NotFoundPage';
import { RootState } from '../../RootState';
import { SiteProps } from '../../SiteProps';
import { Language } from '../Localization/localizationDuck';

const CHAR_APPROX_WIDTH = 50;
const ANIMATION_DURATION = 500;
const FRAME_DELAY = 15;
const RIGHT_DELAY = 400;

interface StateProps {
  language: Language;
}

interface NotFoundProps extends StateProps, SiteProps {}

interface NotFoundState {
  leftNumbers: string;
  rightNumbers: string;
  leftNumbersTemplate: string;
  rightNumbersTemplate: string;
  leftFinished: boolean;
  rightFinished: boolean;
}

class NotFound extends React.PureComponent<NotFoundProps, NotFoundState> {
  leftInterval?: number;
  rightInterval?: number;
  rightDelayTimeout?: number;

  constructor(props: NotFoundProps) {
    super(props);

    this.state = {
      leftNumbers: '101010101010101010',
      rightNumbers: '010101010101010101',
      leftNumbersTemplate: '101010101010101010',
      rightNumbersTemplate: '010101010101010101',
      leftFinished: true,
      rightFinished: true,
    };
  }

  componentDidMount() {
    this.calculateSideNumbers();
    window.addEventListener<'resize'>('resize', throttle(
      200,
      false,
      this.calculateSideNumbers,
    ) as EventListener);

    this.setState({
      leftFinished: false,
      rightFinished: false,
    });

    let leftIteration = 0;
    this.leftInterval = window.setInterval(() => {
      this.moveNumber(leftIteration, 0, this.state.leftNumbers.length - 1, 'left');
      leftIteration += 1;
    }, FRAME_DELAY);

    let rightIteration = 0;
    this.rightDelayTimeout = window.setTimeout(() => {
      this.rightInterval = window.setInterval(() => {
        this.moveNumber(
          rightIteration,
          this.state.leftNumbers.length - 1,
          -this.state.leftNumbers.length + 1,
          'right',
        );
        rightIteration += 1;
      }, FRAME_DELAY);
    }, RIGHT_DELAY);
  }

  componentWillUnmount() {
    clearInterval(this.rightInterval);
    clearInterval(this.leftInterval);
    clearTimeout(this.rightDelayTimeout);
    window.removeEventListener<'resize'>('resize', throttle(
      200,
      false,
      this.calculateSideNumbers,
    ) as EventListener);
  }

  calculateSideNumbers = () => {
    const charsNeeded = Math.ceil(window.innerWidth / CHAR_APPROX_WIDTH / 2);
    let leftNumbers = '';
    let rightNumbers = '';

    for (let i = 0; i < charsNeeded; i += 1) {
      leftNumbers = (i % 2).toString() + leftNumbers;
      rightNumbers += ((i + 1) % 2).toString();
    }

    this.setState({
      leftNumbers,
      rightNumbers,
      leftNumbersTemplate: leftNumbers,
      rightNumbersTemplate: rightNumbers,
    });
  };

  moveNumber = (iteration: number, startValue: number, changeOfValue: number, side: string) => {
    const position = Math.floor(
      this.easeInQuad(iteration, startValue, changeOfValue, ANIMATION_DURATION / FRAME_DELAY),
    );

    if (position >= changeOfValue && side === 'left' && this.leftInterval) {
      this.finishLeft();
      clearInterval(this.leftInterval);
    }
    if (position <= 0 && side === 'right' && this.rightInterval) {
      this.finishRight();
      clearInterval(this.rightInterval);
      return;
    }

    const numbersArray = this.state[side + 'NumbersTemplate'].split('');
    numbersArray[position] = '4';
    const numbers = numbersArray.join('');
    if (side === 'left') {
      this.changeLeft(numbers);
    } else if (side === 'right') {
      this.changeRight(numbers);
    }
  };

  changeLeft = (numbers: string) => this.setState({ leftNumbers: numbers });
  changeRight = (numbers: string) => this.setState({ rightNumbers: numbers });

  finishLeft = () =>
    this.setState(prevState => ({
      leftNumbers: prevState.leftNumbersTemplate,
      leftFinished: true,
    }));

  finishRight = () =>
    this.setState(prevState => ({
      rightNumbers: prevState.rightNumbersTemplate,
      rightFinished: true,
    }));

  easeInQuad = (
    currentIteration: number,
    startValue: number,
    changeInValue: number,
    totalIterations: number,
  ) => changeInValue * (currentIteration / totalIterations) * 2 + startValue;

  render() {
    return (
      <NotFoundComponent
        leftNumbers={this.state.leftNumbers}
        rightNumbers={this.state.rightNumbers}
        leftFinished={this.state.leftFinished}
        rightFinished={this.state.rightFinished}
        locale={this.props.notFoundPageLocale[this.props.language]}
      />
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  language: state.localization.language,
});

export default connect<StateProps, {}, {}, RootState>(
  mapStateToProps,
  () => ({}),
)(withSiteData(NotFound));



// WEBPACK FOOTER //
// /www/client/src/containers/NotFoundPage/NotFoundPage.tsx